import { useContext } from 'react';

import { SignInContext } from '@modules/users';

import { AI_ASSISTANT_SHORT_TITLE, AI_ASSISTANT_TITLE } from '../constants';

const useGroundedQaTerminology = () => {
  const { organization } = useContext(SignInContext);
  const terminology = organization.terminology.groundedQa;

  return {
    short: terminology?.short ?? AI_ASSISTANT_SHORT_TITLE,
    long: terminology?.long ?? AI_ASSISTANT_TITLE,
  };
};

export default useGroundedQaTerminology;
